export default __webpack_public_path__ + "static/rovo-button-dark-669a1f9239816abdccf7812abc556eb101b93644727b70875f357c4ef5c26ad8.png";